module.exports = __webpack_public_path__ + "static/img/xx.06dd12d7.svg";